<template>
  <div class="row">
    <!-- responsive layout -->
    <div :class="mobile ? '' : 'container'">
      <div class="card" style="margin: 100px 0">
        <div class="card-content">
          <!-- login form -->
          <form @submit.prevent="login">
            <!-- username field -->
            <div class="row">
              <div class="input-field col s12">
                <i class="material-icons prefix">email</i>
                <input id="email" type="email" v-model="user.email" required class="validate" />
                <label for="email">Email</label>
              </div>
            </div>

            <!-- password field -->
            <div class="row">
              <div class="input-field col s12">
                <!-- icon password field visibility -->
                <i
                  @click="visibility = !visibility"
                  class="material-icons prefix"
                >{{ visibility ? 'visibility' : 'visibility_off' }}</i>
                <input
                  id="password"
                  :type="visibility ? 'text' : 'password'"
                  v-model="user.password"
                  required
                  class="validate"
                />
                <label for="password">Password</label>
              </div>
            </div>

            <!-- submit button -->
            <div class="row center">
              <button class="btn indigo">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      user: {
        email: "",
        password: ""
      },
      visibility: false
    };
  },
  methods: {
    login() {
      this.$store.dispatch("login", {
        email: this.user.email,
        password: this.user.password
      });
    }
  },
  computed: {
    mobile() {
      return window.innerWidth < 420;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Login.vue